<template>
  <div class="">
    <toptitle :title="topTitle" :subtitle="topSubTitle"></toptitle>
    <div class="recruit-container">
      <div class="container">
        <div class="row d-flex">
          <leftsidebar class="order-md-1 order-2"></leftsidebar>
          <div class="products-box col-md-9 order-md-2 order-1">
            <div class="products-title">
              <span v-if="currentLanguage == 'CN'">招聘岗位</span>
              <span v-else-if="currentLanguage == 'EN'">Recruitment</span>
              <span v-else-if="currentLanguage == 'JP'">採用情報</span>
            </div>
            <div class="zpgw-container" v-for="(item, index) in recruitData" :key="index">
              <i class="zpgw-header-box"></i>
              <div class="zpgw-header d-md-flex justify-content-between">
                <p class="zpgw-title">{{item.title}}</p>
                <div class="zpgw-info d-md-flex">
                  <span>工作地点：{{item.address}}</span>
                  <span>学历：{{item.xl}}</span>
                  <span>更新时间：{{item.time}}</span>
                </div>
              </div>
              <div class="zpgw-text">
                <p class="zpgw-text-title">任职要求:</p>
                <pre>
                  <p class="zpgw-text-info">{{item.rzyq}}</p>
                </pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import recruitDataCN from '../data/CN/recruitData_CN.json'
import recruitDataEN from '../data/EN/recruitData_EN.json'
import recruitDataJP from '../data/JP/recruitData_JP.json'
export default {
  data() {
    return {
      topTitle: '人才招聘',
      topSubTitle: '光维科技 邀请您的加入',
      recruitData: [],
      currentLanguage: '' // 当前语言
    }
  },
  mounted() {
      const _this = this
      window.addEventListener('setItemEvent', function(e) {
          // e.key : 是值发生变化的key
          // 例如 e.key==="token";
          // e.newValue : 是可以对应的新值
          if (e.key === 'language') {
              var d = e.newValue
            _this.currentLanguage = e.newValue
              if (d === 'CN') {
                  _this.recruitData = recruitDataCN
              } else if (d === 'EN') {
                  _this.recruitData = recruitDataEN
              } else if (d === 'JP') {
                  _this.recruitData = recruitDataJP
              }
          }
      })
  },
  methods: {
    // 查询所有的招聘信息
    findRecruit: async function() {
      var lg = localStorage.getItem('language')
      this.currentLanguage = lg
      if (lg === 'CN') {
          this.recruitData = recruitDataCN
      } else if (lg === 'EN') {
          this.recruitData = recruitDataEN
      } else if (lg === 'JP') {
          this.recruitData = recruitDataJP
      }
    }
  },
  created() {
    this.findRecruit()
  }
}
</script>
<style scoped>

@media (max-width: 768px) {
  .zpgw-info {
    margin-top: 10px;
  }
  .zpgw-info span{
    margin-left: 0 !important;
  }
  .zpgw-text-info {
  text-indent: 0 !important;
  padding-left: 0 !important;
}
.zpgw-text {
  margin-top: 10px !important;
  color: #999;
}
}
.recruit-container {
  padding: 30px 0;
}

.products-box {
  margin-bottom: 26px;
}
.products-title {
  border-bottom: 1px solid #cccccc;
  margin-bottom: 6px;
}
.products-title span {
  display: inline-block;
  font-size: 22px;
  padding: 4px 0;
  position: relative;
  bottom: -1px;
  border-bottom: 1px solid #048bd4;
  color: #048bd4;
}

.zpgw-container {
  padding: 20px;
  background-color: #f6f6f6;
  margin-top: 30px;
  position: relative;
}

.zpgw-header-box {
  display: inline-block;
  width: 8px;
  height: 32px;
  background-color: #048bd4;
  position: absolute;
  left: 0;
}

.zpgw-title {
  font-size: 22px;
  color: #048bd4;
}

.zpgw-info {
  font-size: 14px;
  color: #999;
}
.zpgw-info span{
  display: block;
  margin-left: 30px;
  line-height: 33px;
}
.zpgw-info span:first-child {
  margin: 0;
}

.zpgw-text {
  margin-top: 20px;
  color: #999;
}
.zpgw-text-title {
  font-size: 18px;
  line-height: 36px;
}
.zpgw-text-info {
  font-size: 15px;
  line-height: 32px;
  color: #999;
  padding-left: 40px;
}

.lianxifangshi {
  margin-top: 30px;
}
.lxfs-container {
  color: #999;
  width: 100%;
  padding-top: 14px;
  line-height: 38px;
}
</style>